<template>
  <div class="tabs">
    <div class="m itit">
      <div class="bt ititsdpp">门/窗获奖品牌</div>
      <div class="iprocoount">提供最新最权威的门窗行业十大品牌排行榜单</div>
    </div>

    <div class="m card">
      <el-tabs type="border-card" ref="tabs">
        <el-tab-pane v-for="(item, index) in tabs" :key="index" :label="item.title">
          <prize :mode="item.key == 0 ? 0 : 1" :show-data="dataPrize[item.key]" />

        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Prize from "@/components/home/Prize";

export default {
  name: "Tabs",
  components: { Prize },
  data() {
    return {
      tabs: [


        { key: 2, title: "高端定制入户门十大品牌" },
        { key: 3, title: "别墅门十大品牌" },
        { key: 4, title: "定制户门十大品牌" },

        { key: 0, title: "特别奖" },
      ]
      ,
      dataPrize: [
                [

                    {
                        id: 3,
                        bak1: "门窗·户门领军企业",
                        name: "新豪轩",
                        logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/1d877518-e79e-40b3-a7ab-34c9314071c1.jpg"
                    },
                    {
                        id: 1,
                        bak1: "高端定制入户门领军企业",
                        name: "雅帝乐",
                        logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/423c20a9-dc30-456f-b22e-0e73977344c3.jpg"
                    },
                    {
                        id: 5,
                        bak1: "高端定制入户门领导品牌",
                        name: "梵帝斯",
                        logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/62f1eb7f-b7dc-4d22-978a-3da77e0e149a.jpg"
                    },

                    {
                        id: 6,
                        bak1: "别墅门领军企业",
                        name: "熊熊",
                        logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/d6d8919c-0422-4f11-91f6-c6373dcabdc0.jpg"
                    },
                  {
                    id: 7,
                    bak1: "铜门最具影响力品牌",
                    name: "九太子",
                    logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/8edb4b9c-0b2e-462e-8d63-46f2952c82c3.jpg"
                  },
                  {
                    id: 2,
                    bak1: "不锈钢烤漆大门首选品牌",
                    name: "钻石豪门",
                    logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/8291e180-6e18-4a91-89fc-7b1dfd5f2842.jpg"
                  },
                  {
                    id: 8,
                    bak1: "精雕全铝门首选品牌",
                    name: "精武门",
                    logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/677fc05a-28f2-4938-8c66-c8258ecfe0e8.jpg"
                  },
                
                    {
                        id: 7,
                        bak1: "别墅门专利技术金奖",
                        name: "天赐福",
                        logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/eed5c81f-f99a-4f1d-9e94-8b5218d4f4c6.jpg"
                    },
                    {
                        id: 2,
                        bak1: "别墅门最具影响力品牌",
                        name: "百年明牌",
                        logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/2e7c2e6b-ef7a-4df8-94c1-8974fa17a265.jpg"
                    },
                    {
                        id: 8,
                        bak1: "防褪色工艺品质金奖",
                        name: "永佳",
                        logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/1b43345b-77c4-4c59-9c1b-1635e829595a.jpg"
                    },
                    {
                        id: 9,
                        bak1: "别墅门标杆品牌",
                        name: "凯雷德",
                        logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/74c1829c-4d95-4a94-b20a-1d0d4d44b859.jpg"
                    },
                  {
                    id: 4,
                    bak1: "别墅门年度口碑品牌",
                    name: "大掌门",
                    logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/a0707c21-ad42-40e7-8a0c-e497a8701677.jpg"
                  },
                  {
                    id: 8,
                    bak1: "别墅门新锐品牌",
                    name: "新普轩",
                    logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/2b2d488f-23a1-43fd-9a64-35c9f80e17b1.jpg"
                  },
                  {
                    id: 9,
                    bak1: "别墅门先锋品牌",
                    name: "久盛",
                    logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/da16a1d8-6c1d-4fcf-a5cf-8cdca04e87c8.jpg"
                  },
                  {
                    id: 4,
                    bak1: "别墅门优质品牌",
                    name: "步步升",
                    logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/53e61711-26f7-46cd-b6c0-be4a3673e1a0.jpg"
                  },
                  {
                    id: 4,
                    bak1: "别墅门消费者信赖品牌",
                    name: "金帝豪",
                    logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/5dc88fcb-72c9-40e1-be3f-d2d49d30c503.jpg"
                  }
                  ,
                  {
                    id: 8,
                    bak1: "豪宅铜门首选品牌",
                    name: "商铜",
                    logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/20d0f9f5-d884-48eb-b14d-96ab4103e879.jpg"
                  },
                  {
                    id: 9,
                    bak1: "高端定制入户门最具潜力新锐品牌",
                    name: "铭铁匠",
                    logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/68375f5a-9833-482b-844d-0c366e9f98a7.jpg"
                  },
                  {
                    id: 4,
                    bak1: "高端定制入户门设计先锋品牌",
                    name: "爱仕堡",
                    logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/fbea19ba-2f85-41a7-bbfa-5d3babda5334.jpg"
                  },
                  {
                    id: 4,
                    bak1: "门业全品类年度标杆企业",
                    name: "天赐福",
                    logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/3e449a5e-c38f-4589-a588-888aa6882d2d.jpg"
                  }
                ],
                //别墅门十大领导品牌
                [

                { id: 10, name: "西州艺墅门", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2024-07-10/a06946c2-6875-4684-9ec6-37413d55efd0.jpg" },
                { id: 8, name: "年年红", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2024-07-10/1db5f5da-f08e-412e-9eef-6e4dcc856168.jpg" },
                { id: 5, name: "精武门", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2024-07-10/5304ccc3-5c8e-4be2-b631-5c603f13cc27.jpg" },
                { id: 7, name: "久盛", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2024-07-10/45ecfbf8-b6a3-444f-a147-43a5c55d9178.jpg" },
                { id: 4, name: "金胜山", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2024-07-10/b7eff443-4823-4c6f-a9b6-b4a317620872.jpg" },
                { id: 3, name: "金帝豪", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2024-07-10/8da7cde3-2e1c-4b5d-8415-2b9af1aadedf.jpg" },
                { id: 1, name: "步步升", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2024-07-10/9119dd93-199f-4ff2-9dd9-6fafd673738f.jpg" },
                { id: 6, name: "久安", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2024-07-10/535416a8-e3c5-48cd-bc71-6e2067b5bc2d.jpg" },
                { id: 9, name: "沁牌", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2024-07-10/65870eb4-a68e-4a23-9da4-95326b47054b.jpg" },
                { id: 2, name: "大掌门", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2024-07-10/f08a125d-1e6d-4466-b3d1-e3bed5570af6.jpg" },
                ],
                //高端定制入户门十大品牌
                [
                { id: 10, name: "雅帝乐", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/d5c5ae4f-f885-439e-b53d-13a07a13cb25.jpg" },
                  { id: 5, name: "奢曼", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/2097cc2b-4517-4020-b128-0d5b5c4cbfde.jpg" },
                  { id: 7, name: "凡帝罗", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/eb20e1f4-ca53-4c5f-97d7-47b90d8f4ad8.jpg" },
                  { id: 2, name: "法兰帝", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/defe9f69-5dfb-48a0-b4b1-6c745f5197f4.jpg" },
                  { id: 8, name: "艺之帝", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/f45bfedf-afd9-4bf0-8290-81b3dfce6bbd.jpg" },
                  { id: 1, name: "爱仕堡", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/34e57794-ac4a-40b5-a4ec-f24fe1968e9a.jpg" },
                  { id: 3, name: "皇士金盾", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/ae97e3c2-053e-4ab9-ba5f-51bba920bbf1.jpg" },
                  { id: 4, name: "臣和", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/555e933c-4dff-400c-a968-6ddaf4a1da18.jpg" },
                  { id: 9, name: "德诺特", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/6c16b08e-79ff-48a4-84ae-0e1fe4a9f412.jpg" },
                  { id: 1, name: "艺和", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/504b931c-c966-46ff-916d-936314ba1209.jpg" },

                ]
                ,
                //别墅门十大品牌 1
                [
                  { id: 10, name: "年年红", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/0155b8e4-5bf1-4fb8-937a-8562bb4945fc.jpg" },
                  { id: 9, name: "钻石豪门", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/e7ab8279-0cff-4061-a33c-a0f1c5a7eeab.jpg" },
                  { id: 6, name: "精武门", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/319d8736-f8a5-4769-9d48-4a05af224402.jpg" },
                  { id: 8, name: "金帝豪", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/3f8e5fcc-ed62-4d1e-8f73-d69448f3d4ff.jpg" },
                  { id: 2, name: "久盛", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/0aa6016e-620a-4904-b7ab-e53a85ea1476.jpg" },
                  {id: 8, name: "天赐福", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/4c443bbc-bb78-436f-b1a1-243f5aac0971.jpg"},
                  { id: 2, name: "沁牌", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/da213268-e719-4bae-b05e-eec2922824a8.jpg" },
                  { id: 4, name: "金胜山", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/4d46c588-6277-4c4a-978c-894e9f540af1.jpg" },
                  { id: 5, name: "步步升", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/0c27c75e-7b71-46bb-aa2a-72842c875d8b.jpg" },
                  { id: 6, name: "杭盛", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/377976e9-d036-4bef-aa28-4d2993c73fa5.jpg" },

                ]
                ,
                //定制户门十大品牌
                [
                { id: 1, name: "福熙", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/a97195d5-0da5-40b0-8ef2-0300d1793665.jpg" },
                  { id: 7, name: "臻能", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/7e6a11cb-2b20-4edb-a76e-185e99c658bb.jpg" },
                  { id: 10, name: "精武门", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/1697b3fd-b4de-4655-99b2-eef87f13358e.jpg" },
                { id: 5, name: "安普曼", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/8bc4a23a-03cc-4cf0-af06-62bc996f6ddb.jpg" },
                  { id: 8, name: "喜传天下", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/54dfbe66-0229-42b1-a2f1-8288669b120d.jpg" },
                  { id: 1, name: "天赐福", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/52620dea-02b8-4ed7-bbfc-0ad33847308c.jpg" },
                { id: 2, name: "京京", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/ca27b419-db21-42ed-8255-ec0ba960f617.jpg" },
                { id: 6, name: "家德利", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-07-11/e8a73825-4b8f-48b9-a746-17e44fd33c7b.jpg" },
                  { id: 2, name: "鸿创", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-08-17/a6ef0714-e716-4f97-9cb3-6cda2f60933d.jpg" },
                { id: 4, name: "辛肯", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2026-08-17/c740697e-1e80-4f97-a4d9-7ddb084c2c2f.jpg" },


                ]
                ,
                //高端系统入户门十大品牌
                [

                { id: 5, name: "英可纳", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2024-07-10/06efeac3-168b-480d-a2b7-6001b009b755.jpg" },
                { id: 1, name: "德诺特", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2024-07-10/72ed0834-9e33-4adc-95dc-ae313b668d32.jpg" },
                { id: 3, name: "卡诺嘉", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2024-07-10/a3d09744-0299-4c10-8fa3-24002d7b21f7.jpg" },
                { id: 6, name: "跃龙门", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2024-07-10/546430a0-59a8-46a9-a174-e0d5004e4df8.jpg" },
                { id: 4, name: "醒石", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2024-07-10/e2723f81-7a52-4edd-93c1-697e7d16617e.jpg" },
                { id: 2, name: "梵赫", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2024-07-10/af2e392b-4027-43c3-9b0c-01749cc5ebd9.jpg" },
                ]
                ,
                //供应链
                [
                    { id: 1, name: "飞宇门花", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2024-07-10/b24957e7-9de3-4a21-b9c4-b66f7032cfe8.jpg" },
                    { id: 6, name: "毅力铰链", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2024-07-10/86b39d40-4159-46ca-9cb6-4947606f95b4.jpg" },
                    { id: 2, name: "恒泰智能", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2024-07-10/8b953fcb-2fa3-410a-b0b8-c558f92ebfe4.jpg" },
                    { id: 5, name: "雅尊门面", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2024-07-10/0b267476-fcbd-4628-9687-add1965932f4.jpg" },
                    { id: 3, name: "迈门网", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2024-07-10/3539051d-e91c-42e5-a1e2-e2d2d6d82846.jpg" },
                    { id: 4, name: "品承", logoAddressUrl: "https://shanghaiaoying.oss-cn-hangzhou.aliyuncs.com/shayPhoto/2024-07-10/6426a4e1-3c78-41e3-a32e-cbd29812cc7a.jpg" },
                ]
                ,

            ],
    }
  },
  methods: {
    mouseenter(key) {
      console.log(this.$refs.tabs.currentName)
      // this.$refs.tabs.currentName=key
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.tabs.$refs.nav.$nextTick(() => {
        // 此时tab的nav才渲染dom 否则拿不到el-tabs__item
        var target = document.getElementsByClassName("el-tabs__item");
        let that = this;
        for (let i = 0; i < target.length; i++) {
          target[i].addEventListener("mouseover", () => {
            that.$refs.tabs.handleTabClick(1, String(i));
          });
        }
      });
    });
  },

};
</script>

<style scoped lang="scss">
div {
  overflow: initial;
}

.tabs {
  /* border: 1px solid red; */
  /* clear: both; */
}

.ad {
  //  border: 1px solid red;
  height: 60px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  .img {

    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: white;
    font-weight: 600;
    background-color: #B80D0D;
    font-size: 24px;
  }
}

.itit {
  border-bottom: #eee 3px solid;
  position: relative;
  height: 50px;
  margin-bottom: 0.7vw;
  /* overflow: inherit */
}

.itit .bt {
  font-size: 24px;
  height: 48px;
  line-height: 48px;
  position: absolute;
  bottom: -3px;
  left: 0px;
  z-index: 2;
}

.ititsdpp {
  background: url("@/assets/image/titsdpp.png") left center no-repeat;
  background-size: auto 26px;
  text-indent: 30px;
  border-bottom: #d4237a 3px solid;
}

.itit .iprocoount {
  left: 230px;
  font-size: 14px;
  color: #999;
  height: 30px;
  line-height: 30px;
  position: absolute;
  top: 16px;
  background: url("@/assets/image/ijoincount.png") left center no-repeat;
  text-indent: 22px;
}

/deep/ .el-tabs--border-card>.el-tabs__header {
  /* background-color: white; */
  border-bottom: 0;
}

/deep/ .el-tabs__item {
  overflow: initial;

}

/deep/ .el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover {
  color: #9a3732;
  font-weight: 800;
}

/deep/ .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
  color: #9a3732;
  font-weight: 800;
}

.card {
  padding-bottom: 2vw;

  img {
    // background-color: red;
    // width: 100%;
    // height: 100%;
  }
}</style>